/**
 * Format finder. Per content/format-finder.md.
 *
 * Everything this script touches is already in the HTML: every answer, every
 * comparison and the formats table are server rendered. The script reveals
 * the three-question picker and narrows the answers to the one that matches,
 * so a reader without JavaScript loses the shortcut and keeps the answers.
 */
(function () {
  var root = document.querySelector('[data-finder]');
  if (!root) return;

  var picker = root.querySelector('[data-finder-picker]');
  var note = root.querySelector('[data-finder-note]');
  var reset = root.querySelector('[data-finder-reset]');
  var empty = root.querySelector('[data-finder-empty]');
  var heading = root.querySelector('[data-finder-answers-heading]');
  var answersNote = root.querySelector('[data-finder-answers-note]');
  var answers = [].slice.call(root.querySelectorAll('[data-finder-answer]'));

  if (!picker || !answers.length) return;

  picker.hidden = false;

  var labelIncomplete = root.getAttribute('data-label-incomplete') || '';
  var labelYourAnswer = root.getAttribute('data-label-your-answer') || '';
  var labelAllAnswers = root.getAttribute('data-label-all-answers') || '';

  function track(event, detail) {
    if (!window.dataLayer) return;
    var payload = { event: event };
    for (var key in detail) {
      if (Object.prototype.hasOwnProperty.call(detail, key)) payload[key] = detail[key];
    }
    window.dataLayer.push(payload);
  }

  function selected(name) {
    var input = picker.querySelector('input[name="' + name + '"]:checked');
    return input ? input.value : '';
  }

  function setSelected(name, value) {
    var input = picker.querySelector('input[name="' + name + '"][value="' + value + '"]');
    if (input) input.checked = true;
  }

  function scrollTo(element) {
    element.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start'
    });
  }

  function matches(panel, where, job, skin) {
    if (panel.getAttribute('data-where') !== where) return false;
    if (panel.getAttribute('data-job') !== job) return false;
    var states = (panel.getAttribute('data-skin') || 'any').replace(/\s+/g, '');
    if (states === 'any' || states === '') return true;
    return states.split(',').indexOf(skin) !== -1;
  }

  function showAll() {
    answers.forEach(function (panel) {
      panel.hidden = false;
    });
    if (empty) empty.hidden = true;
    if (reset) reset.hidden = true;
    if (heading && labelAllAnswers) heading.textContent = labelAllAnswers;
    if (answersNote) answersNote.hidden = false;
  }

  function showOnly(found) {
    answers.forEach(function (panel) {
      panel.hidden = panel !== found;
    });
    if (empty) empty.hidden = !!found;
    if (reset) reset.hidden = false;
    if (heading && labelYourAnswer) heading.textContent = labelYourAnswer;
    if (answersNote) answersNote.hidden = true;
  }

  function apply(shouldScroll) {
    var where = selected('where');
    var job = selected('job');
    var skin = selected('skin');

    if (!where || !job || !skin) {
      showAll();
      if (note) note.textContent = where || job || skin ? labelIncomplete : '';
      return;
    }

    var found = null;
    answers.forEach(function (panel) {
      if (!found && matches(panel, where, job, skin)) found = panel;
    });

    showOnly(found);
    if (note) note.textContent = '';
    if (found && shouldScroll) scrollTo(found);

    track('format_finder_answer', {
      finder_where: where,
      finder_job: job,
      finder_skin: skin,
      finder_result: found ? found.id.replace(/^answer-/, '') : 'none'
    });
  }

  picker.addEventListener('change', function () {
    apply(true);
  });

  picker.addEventListener('submit', function (event) {
    event.preventDefault();
    apply(true);
  });

  if (reset) {
    reset.addEventListener('click', function () {
      [].slice.call(picker.querySelectorAll('input[type="radio"]')).forEach(function (input) {
        input.checked = false;
      });
      showAll();
      if (note) note.textContent = '';
      scrollTo(picker);
      track('format_finder_reset', {});
    });
  }

  // Comparison jump links are plain anchors; the event is the only enhancement.
  root.ownerDocument.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('[data-finder-jump]') : null;
    if (!link) return;
    track('format_compare_jump', { finder_compare: link.getAttribute('data-finder-jump') });
  });

  // A shared link such as #answer-moist-face-both should open on that answer,
  // with the picker set to match so the reader sees how it was reached. The
  // same applies when the hash changes on a page that is already open.
  function openFromHash() {
    var hash = window.location.hash;
    if (hash.indexOf('#answer-') !== 0) return;
    var target = document.getElementById(hash.slice(1));
    if (!target || answers.indexOf(target) === -1) return;
    setSelected('where', target.getAttribute('data-where'));
    setSelected('job', target.getAttribute('data-job'));
    var states = (target.getAttribute('data-skin') || 'any').replace(/\s+/g, '');
    if (states !== 'any' && states !== '') setSelected('skin', states.split(',')[0]);
    showOnly(target);
    if (note) note.textContent = '';
  }

  openFromHash();
  window.addEventListener('hashchange', openFromHash);
})();
